import React, { useState } from 'react';

// Hooks
import useCustomerRecover from '@src/hooks/useCustomerRecover';

// Comps
import {TextField} from '@arctheme-components/elements/TextField/TextField';
import {Link} from '@arctheme-components/elements/Link/Link';
import ButtonSpinner from '@arctheme-components/blocks/ButtonSpinner/ButtonSpinner';
import {Paragraph} from '@arctheme-components/elements/Paragraph/Paragraph';

type Props = {
    onCancel?: (event: React.ClickEvent<HTMLButtonElement>) => void;
    section?: any;
};

const AccountForgotPassword = ({ onCancel, section }: Props) => {
    const {
        email_label,
        email_placeholder,
        button_label_forgot_password_submit,
        button_style_forgot_password_submit,
        button_label_cancel
    } = section;

    // States
    const [email, setEmail] = useState('');

    // Hooks
    const { loading, errorMessage, successMessage, handleRecoverPassword } = useCustomerRecover();

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        handleRecoverPassword(email);
    };

    return (
        <>
            {errorMessage ? (
                <Paragraph
                    text={errorMessage}
                    type='errors text-center'
                />
            ) : successMessage ? (
                <Paragraph
                    text={successMessage}
                    type='success text-center'
                />
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className='flex flex-col gap-y-4 items-center'>
                        <div className={`w-full grid grid-cols-2`}>
                            <h4 className={`w-full text-left`}>RESET PASSWORD</h4>
                            <p className={`b2 w-full text-right text-[#C0C0C0]`}>*Required field</p>
                        </div>
                        <TextField
                            className={`h4 w-full`}
                            inputType='email'
                            id='email'
                            name='email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required={true}
                            label={email_label}
                            placeholder={email_placeholder}
                        />

                        <ButtonSpinner
                            isLoading={loading}
                            classes={`button button-primary w-full`}
                        >
                            {button_label_forgot_password_submit}
                        </ButtonSpinner>

                        <Link
                            link='#'
                            classes='button button-secondary w-full link--underlined text-[#696969]'
                            onClick={onCancel}
                        >
                            {button_label_cancel}
                        </Link>
                    </div>
                </form>
            )}
        </>
    );
};

export default AccountForgotPassword;